export class Exception implements Error {

    message: string;
    name: string;
    stack: string;
    type: 'warning' | 'error' | 'fatal' | 'hidden';

    private constructor(err: Error | string, type: 'warning' | 'error' | 'fatal' | 'hidden') {
        if (typeof (err) === 'string') {
            err = new Error(err);
        }
        this.message = err.message;
        this.type = type;
        this.name = err.name;
        this.stack = err.stack;
    }

    static fatal(err: Error | string): Exception {
        return new Exception(err, 'fatal');
    }

    static error(err: Error | string): Exception {
        return new Exception(err, 'error');
    }

    static warning(err: Error | string): Exception {
        return new Exception(err, 'warning');
    }

    static hidden(err: Error | string): Exception {
        return new Exception(err, 'hidden');
    }

}
